import React from 'react';
import { Heart, Award, Users, Clock } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: <Heart size={32} />,
      title: 'Compassionate Care',
      description: 'We treat every animal with love and respect, whether pets or street animals'
    },
    {
      icon: <Award size={32} />,
      title: 'Expert Treatment',
      description: 'Experienced veterinary care with proven success in critical cases'
    },
    {
      icon: <Users size={32} />,
      title: 'Community Service',
      description: 'Free and low-cost services for street dogs and cows in need'
    },
    {
      icon: <Clock size={32} />,
      title: '24/7 Availability',
      description: 'Round-the-clock emergency services when your pet needs us most'
    }
  ];

  return (
    <div style={{ paddingTop: '5rem' }}>
      {/* About Hero */}
      <section className="container" style={{ marginTop: '3rem', marginBottom: '4rem' }}>
        <h1 className="heading-1" style={{ marginBottom: '1.5rem' }}>
          About Teja's Pet Care
        </h1>
        <p className="telugu-text heading-3" style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
          తేజ పేట కేర్
        </p>
        <div className="body-large" style={{ maxWidth: '800px' }}>
          <p style={{ marginBottom: '1.5rem' }}>
            Welcome to <strong>Teja's Pet Care</strong>, Bhimavaram's most trusted 24-hour veterinary hospital. 
            With a stellar <strong>4.8-star rating from 269 Google reviews</strong>, we've earned the trust of pet parents 
            throughout Andhra Pradesh through our commitment to compassionate, expert veterinary care.
          </p>
          <p style={{ marginBottom: '1.5rem' }}>
            Located on Cosmo Club Road near Varma's Kitchen in Bhimavaram, our clinic specializes in emergency care, 
            critical treatment, and comprehensive veterinary services. We're known for our expertise in treating 
            life-threatening conditions like parvovirus, with numerous success stories of bringing pets back from 
            critical conditions.
          </p>
          <p>
            What sets us apart is our genuine love for all animals. Beyond caring for beloved pets, we proudly offer 
            free and low-cost services for street dogs and cows, embodying our belief that every animal deserves 
            quality healthcare. Our ethical practice and community-focused approach have made us a pillar of animal 
            welfare in Bhimavaram.
          </p>
        </div>
      </section>

      {/* Our Values */}
      <section style={{ background: 'var(--bg-section)', padding: '4rem 1.5rem' }}>
        <div className="container">
          <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            Our Core Values
          </h2>
          <div className="ai-grid">
            {values.map((value, index) => (
              <div key={index} className="product-card">
                <div className="service-icon">
                  {value.icon}
                </div>
                <h3 className="product-card-title">{value.title}</h3>
                <p className="product-card-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="container" style={{ marginTop: '4rem', marginBottom: '4rem' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 className="heading-2" style={{ marginBottom: '1.5rem' }}>
            Our Mission
          </h2>
          <p className="body-large" style={{ marginBottom: '1.5rem', color: 'var(--text-body)' }}>
            To provide world-class veterinary care to every animal that comes through our doors, regardless of 
            their background. We believe that compassionate, ethical treatment should be accessible to all animals, 
            from cherished family pets to street animals in need.
          </p>
          <p className="body-large" style={{ color: 'var(--text-body)' }}>
            Our experienced team is dedicated to staying at the forefront of veterinary medicine, ensuring that 
            your pets receive the most advanced and effective treatments available. Whether it's a routine checkup 
            or a life-threatening emergency, we approach every case with the same level of care and expertise.
          </p>
        </div>
      </section>

      {/* Experience Highlights */}
      <section style={{ background: 'var(--accent-wash)', padding: '3rem 1.5rem' }}>
        <div className="container">
          <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: '2rem' }}>
            Why Families Trust Us
          </h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '2rem',
            textAlign: 'center'
          }}>
            <div>
              <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--accent-text)' }}>4.8⭐</div>
              <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>Google Rating</div>
            </div>
            <div>
              <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--accent-text)' }}>269+</div>
              <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>Happy Reviews</div>
            </div>
            <div>
              <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--accent-text)' }}>24/7</div>
              <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>Emergency Care</div>
            </div>
            <div>
              <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--accent-text)' }}>100%</div>
              <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>Dedicated Service</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;